/* eslint-disable */
import ApiService from '@/services/Base/ApiService';

const getDefaultState = () => {
  return {
    savedSourceDatas: null,
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  async fetchModernSourceData(context) {
    try {
      const saveDetail = context.state.savedSourceDatas;
      if (saveDetail) {
        return saveDetail;
      } else {
        const response = await ApiService.get('ModernSouceData');
        if (response.statusCode === 200) {
          context.state.savedSourceDatas = response.result;
          return response.result;
        } else {
          throw error;
        }
      }
    } catch (error) {
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
